import type { LanePagedResult, LanesApi } from '../../models';

export const normalizeLanes = (result: LanePagedResult | null): LanesApi => {
  if (result === null) {
    return { data: [], total: 0 };
  }

  return {
    data: (result.items ?? []).map((item) => ({ ...item, id: String(item.laneKey) })),
    total: result.totalCount,
  };
};
